function l(t) {
  return typeof t == "string" ? document.querySelector(t) : t();
}
function p(t) {
  var n = t === void 0 ? {} : t,
    r = n.ref,
    i = n.afterPortal;
  return {
    props: {
      getContainer: [String, Function]
    },
    watch: {
      getContainer: "portal"
    },
    mounted: function mounted() {
      this.getContainer && this.portal();
    },
    methods: {
      portal: function portal() {
        var o = this.getContainer,
          a = r ? this.$refs[r] : this.$el,
          e;
        o ? e = l(o) : this.$parent && (e = this.$parent.$el), e && e !== a.parentNode && e.appendChild(a), i && i.call(this);
      }
    }
  };
}
export { p as PortalMixin };
